import pica from 'pica'

import { dataUrlToFile } from './fileConverter'
import { loadImageFromFile } from './loadImage'
import { isFileValidImage } from './verifyFileType'

async function resize(image: HTMLImageElement, height: number, width: number) {
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height

  return (await pica().resize(image, canvas, { filter: 'mks2013' })).toDataURL(
    'image/png'
  )
}

export async function resizeImage(maxLargerSize: number, file: File) {
  try {
    const isImage = isFileValidImage(file)
    if (!isImage) return null

    const image = await loadImageFromFile(file)

    const { height, width } = image
    const largerSizeValue = height > width ? height : width
    const ratio =
      largerSizeValue > maxLargerSize ? maxLargerSize / largerSizeValue : 1

    const newImageDataUrl = await resize(image, height * ratio, width * ratio)
    const newImage = await dataUrlToFile(newImageDataUrl, file.name, file.type)
    return newImage
  } catch {
    return null
  }
}

export const resizeAvatarImage = async (file: File) =>
  await resizeImage(192, file)
export const resizeHDImage = async (file: File) => await resizeImage(1920, file)
